import { render, staticRenderFns } from "./afterSaleInfo.vue?vue&type=template&id=9d8b3220&scoped=true"
import script from "./afterSaleInfo.vue?vue&type=script&lang=js"
export * from "./afterSaleInfo.vue?vue&type=script&lang=js"
import style0 from "./afterSaleInfo.vue?vue&type=style&index=0&id=9d8b3220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8b3220",
  null
  
)

export default component.exports